import React from 'react';
import { Link } from 'react-router-dom';

export default function LinkStyled({ className, to, href, displayWhite, onClick = () => void 0, children }) {
  const linkStyledClasses = `link-styled dib fz14@sm fz16 lh1.25 fw500 tdn p0 curp posr ff-gr ${ displayWhite ? 'c-white link-styled--white' : 'c-black'} ${ className || '' }`;

  return to ? (
    <Link
      className={linkStyledClasses}
      onClick={onClick}
      to={to}
    >
    { children }
    </Link>
  )
  : href ? (
    <a
      className={linkStyledClasses}
      onClick={onClick}
      href={href}
    >
    { children }
    </a>
    )
  : (
    <span
      className={linkStyledClasses}
      onClick={onClick}
    >
    { children }
    </span>
    )
}
